// extracted by mini-css-extract-plugin
module.exports = {"navbar":"nav_navbar__2xBWG","myNavbar":"nav_myNavbar__3wVvh","icon1":"nav_icon1___uSTY"};